<template>
  <div class="d-flex align-items-center">
    <b-button
      variant="link"
      v-b-tooltip.hover
      :title="prompt"
    >
      <b-icon-info-circle aria-hidden="true" />
      <span class="sr-only">Panel information</span>
    </b-button>

    <b-button
      variant="link"
      class="ml-n2-0"
      @click="$refs.confirmDelete.$refs.modal.show()"
    >
      <b-icon-trash aria-hidden="true" />
      <span class="sr-only">Delete panel</span>
    </b-button>
    <DeletePanelConfirm ref="confirmDelete" :url="deleteUrl" :name="name" />
  </div>
</template>

<script>
import DeletePanelConfirm from '@/xvisor/components/custom/DeletePanelConfirm.vue';

export default {
  components: {
    DeletePanelConfirm,
  },
  props: {
    deleteUrl: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    prompt: {
      type: String,
      required: true,
    },
  },
};
</script>
